import { StyleSheet } from 'react-native';

import { Fonts, Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import cardShadow from '../../Styles/cardShadow';

export default StyleSheet.create({
  containerStyle: theme => ({
    flex: 1,
    justifyContent: 'space-between',
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    paddingHorizontal: 12,
    paddingTop: 15.5,
    paddingBottom: 8.8,
    ...cardShadow,
  }),
  titleContainerStyle: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  titleTextStyle: theme => ({
    marginHorizontal: 8,
    fontSize: 18,
    ...Fonts.type.bold,
    letterSpacing: 0,
    color: theme.colors.headerColor,
    width: '70%',
    lineHeight: 28,
  }),
  usageContainerStyle: {
    flexDirection: 'row',
    alignItems: 'flex-end',
  },
  unlimitedRemainingTextStyle: theme => ({
    fontSize: 42,
    letterSpacing: 0,
    lineHeight: 40,
    color: theme.colors.textColorTwo,
    fontFamily: Fonts.type.VodafoneLt,
  }),
  remainingTextStyle: theme => ({
    fontSize: 32,
    letterSpacing: 0,
    lineHeight: 40,
    color: theme.colors.textColorTwo,
  }),
  unlimitedRemainingUnitTextStyle: theme => ({
    fontSize: 26,
    letterSpacing: 0,
    lineHeight: 32,
    color: Colors.thinDark,
    marginLeft: 1,
    fontFamily: Fonts.type.VodafoneLt,
  }),
  remainingUnitTextStyle: theme => ({
    fontSize: 24,
    letterSpacing: 0,
    lineHeight: 32,
    color: theme.colors.textColorTwo,
  }),
  spacingViewStyle: {
    width: 8,
    height: 1,
  },
  usageLeftTextStyle: theme => ({
    fontSize: 16.6,
    letterSpacing: 0,
    color: theme.colors.textColorTwo,
    lineHeight: 20,
  }),

  unlimitedFooterTextStyle: {
    fontSize: 14.6,
    letterSpacing: -0.24,
    marginTop: 4,
    color: Colors.light_grey,
  },
  footerTextStyle: theme => ({
    fontSize: 14.6,
    letterSpacing: -0.24,
    marginTop: 4,
    color: theme.colors.textColorTwo,
  }),
  footerContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  buttonTextStyle: {
    ...Fonts.type.bold,
    fontSize: 16.7,
    paddingHorizontal: 15,
    lineHeight: 22.9,
  },
  buttonStyle: {
    height: 31.3,
  },
  buttonSpace: {
    height: 31.3,
  },
});
